import { useLayoutEffect } from 'react';
import { AuthUser } from 'types';
import { getAuthUser } from 'api';
import { redirectToShopify } from 'utils/services';
import { isBrowser } from 'utils/validators';

export type SignInPlaceholderProps = {
  shopifySid: string;
};

export const SignInPlaceholder = ({ shopifySid }: SignInPlaceholderProps) => {
  useLayoutEffect(() => {
    handleShopifySignIn().then();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleShopifySignIn = async () => {
    const userResponse: AuthUser = await getAuthUser(undefined, { shopify_sid: shopifySid });
    if (userResponse.additional) {
      // todo - check Shopify base url and delete this comment
      const { shopify_sid, shopify_sign } = userResponse.additional;
      shopify_sid && shopify_sign && redirectToShopify(shopify_sid, shopify_sign);
    }
  };

  return null;
};
